import React, { ReactNode, createContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import i18n from '~/components/i18n';

interface FilterInputValues {
  agisId: string;
  search: string
}

interface SwissFarmerContextType {
  filterInputValues: FilterInputValues;
  checkedFilters: any[];
}

interface SwissFarmerContextValueType {
  contextValues: SwissFarmerContextType
  setContextValues: (value: SwissFarmerContextType) => void
}

const getDefaultContextValues = (searchParams?: any): SwissFarmerContextType => ({
  filterInputValues: {
    agisId: searchParams?.get('agisId') || '',
    search: searchParams?.get('search') || ''
  },
  checkedFilters: []
})

export const SwissFarmerContext = createContext<SwissFarmerContextValueType>({
  contextValues: getDefaultContextValues(),
  setContextValues: () => 1
})

interface SwissFarmerContextProps {
  children: ReactNode
}

export const getSwissFarmersFilters = () => [
  {
    key: 'search',
    placeholder: i18n.t('EVS-Nr./Farmer-Nr')
  },
  {
    key: 'agisId',
    placeholder: i18n.t('AGIS-ID Betrieb')
  }
]

export const getSwissFarmersFilterInputs = () => [
  {
    key: 'search',
    placeholder: i18n.t('EVS-Nr./Farmer-Nr')
  },
  {
    key: 'agisId',
    placeholder: i18n.t('AGIS-ID Betrieb')
  }
]

const SwissFarmerProviderComp: React.FC<SwissFarmerContextProps> = (props) => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams();
  const [contextValues, setContextValues] = useState<SwissFarmerContextType>(getDefaultContextValues(searchParams))

  useEffect(() => {
    const filters = localStorage.getItem('swissFarmersFilters')
    const swissFarmersFilterInputs = getSwissFarmersFilterInputs()
    const swissFarmersFilters = getSwissFarmersFilters()
    if (filters) {
      const filtersParsed = JSON.parse(filters)
      filtersParsed.forEach(filter => {
        const indexFilter = swissFarmersFilters.findIndex(swissFilter => swissFilter.key === filter.key)
        if (indexFilter < 0) {
          const indexFilterInput = swissFarmersFilterInputs.findIndex(swissFilter => swissFilter.key === filter.key)
          if (indexFilterInput >= 0) {
            filter.placeholder = swissFarmersFilterInputs[indexFilterInput].placeholder
          }
        }
      })
      setContextValues({
        ...contextValues,
        checkedFilters: filtersParsed
      })
    }
  }, [t])

  return <SwissFarmerContext.Provider value={{ contextValues, setContextValues }}>
    {props.children}
  </SwissFarmerContext.Provider>
}
export default SwissFarmerProviderComp
